export enum LoadingPlanStatus {
  PUBLISHED = 'published',
  READY = 'ready',
  DRAFT = 'draft',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  LOADED = 'loaded'
}

export const LoadingPlanStatusLabels: Record<LoadingPlanStatus, string> = {
  [LoadingPlanStatus.PUBLISHED]: 'Published',
  [LoadingPlanStatus.READY]: 'Ready',
  [LoadingPlanStatus.DRAFT]: 'Draft',
  [LoadingPlanStatus.FAILED]: 'Failed',
  [LoadingPlanStatus.IN_PROGRESS]: 'In Progress',
  [LoadingPlanStatus.LOADED]: 'Loaded',
};
